module.exports = __webpack_public_path__ + "static/media/Healthy Hip Anatomy.4ade5ffa.png";